import type { PropsWithChildren } from 'react';

import { Sheet as UISheet } from '@procurify/ui'
import { type ISheetProps as IUISheetProps } from '@procurify/ui'

export interface ISheetProps extends IUISheetProps {}

export const Sheet = ({
  children,
  container,
  isOpen,
}: PropsWithChildren<ISheetProps>) => {
  return (
    <UISheet
      container={container || document.querySelector('#app-content')}
      isOpen={isOpen}
    >
      {children}
    </UISheet>
  )
}

Sheet.Header = UISheet.Header
Sheet.Content = UISheet.Content
Sheet.displayName = 'Sheet'
